import { Validators } from '@angular/forms';
import { AllInputTypes, FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { getIdFormConfig } from '../../../../../views/pages/adminstration/temp-common/utils';
import { LocationModel } from '../../locations';
import { ICreateAddressReqeust } from '../dtos';
import { TranslateService } from '@ngx-translate/core';
import { IGeographicalZoneResponse } from '../../../location-management/geographical-zones/dtos';
import { inject } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ICityResponse } from '../../../location-management/cities/dtos';
import { IAddressResponse } from '../../../..';
import { PublicService } from '../../../../../trash/shared/services/public.service';

export class CreateAddressModel implements ICreateAddressReqeust {
  form: FormInputConfig[] = [];
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private publicService = inject(PublicService);
  location?: LocationModel;
  country?: string;
  state?: string;
  city?: string;
  area?: string;
  district?: string;
  geographicalZones: ListValues[] = [];
  addressLine1?: string;
  addressLine2?: string;
  states: ListValues[] = [];
  cities: ListValues[] = [];
  districts: ListValues[] = [];
  private constructor(request: ICreateAddressReqeust) {
    this.location = LocationModel.create(request.location);
    this.country = request.country;
    this.state = request.state;
    this.city = request.city;
    this.area = request.area;
    this.district = request.district;
    this.addressLine1 = request.addressLine1;
    this.addressLine2 = request.addressLine2;
  }

  static createFromItem(request: IAddressResponse) {
    return !request
      ? CreateAddressModel.createDefault()
      : new CreateAddressModel({
          country: request.country!.id,
          state: request.state!.id,
          city: request.city!.id,
          addressLine1: request.addressLine1,
          addressLine2: request.addressLine2,
          district: request.district!.id,
          location: LocationModel.create(request.location)
        });
  }
  static create(data: ICreateAddressReqeust): CreateAddressModel {
    return new CreateAddressModel(data);
  }

  static createDefault(): CreateAddressModel {
    return CreateAddressModel.create({});
  }

  getAddressFormConfig(
    address: any,
    countries?: ListValues[],
    visiable?: boolean,
    translate?: TranslateService,
    onCountryChange?: (countryId: string) => void,
    onStateChange?: (stateId: string) => void,
    onCityChange?: (cityId: string) => void
  ): FormInputConfig[] {
    this.form = [
      getIdFormConfig(undefined),
      {
        type: AllInputTypes.Select,
        name: 'countryId',
        label: translate?.instant('GENERAL.COUNTRY'),
        placeholder: `${translate?.instant('GENERAL.SELECT')}`,
        widthClass: 'col-12',
        defaultValue: address?.countryId || address?.country?.id,
        isDisable: !visiable,
        listValues: countries,
        change: (value: string) => {
          if (onCountryChange) {
            onCountryChange(value);
          }
        }
        // validation: [
        //   {
        //     function: Validators.required,
        //     errorMessage: translate?.instant('GENERAL.PLEASE_SELECT') + ' ' + translate?.instant('GENERAL.COUNTRY')
        //   }
        // ]
      },
      // {
      //   type: AllInputTypes.Select,
      //   name: 'geographicalZoneId',
      //   label: translate?.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE'),
      //   placeholder: `${translate?.instant('GENERAL.SELECT')}`,
      //   widthClass: 'col-12',
      //   defaultValue: address?.geographicalZoneId || address?.geographicalZone?.id,
      //   isDisable: !visiable,
      //   listValues: this.geographicalZones
      //   // validation: [
      //   //   {
      //   //     function: Validators.required,
      //   //     errorMessage: translate?.instant('GENERAL.PLEASE_SELECT') + ' ' + translate?.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE')
      //   //   }
      //   // ]
      // },
      {
        type: AllInputTypes.Select,
        name: 'stateId',
        label: translate?.instant('LOCATION_MANAGEMENT.STATE'),
        placeholder: `${translate?.instant('GENERAL.SELECT')}`,
        widthClass: 'col-12',
        defaultValue: address?.stateId || address?.state?.id,
        isDisable: !visiable,
        listValues: this.states,
        change: (value: string) => {
          if (onStateChange) {
            onStateChange(value);
          }
        }
        // validation: [
        //   {
        //     function: Validators.required,
        //     errorMessage: translate?.instant('GENERAL.PLEASE_SELECT') + ' ' + translate?.instant('LOCATION_MANAGEMENT.STATE')
        //   }
        // ]
      },
      {
        type: AllInputTypes.Select,
        name: 'cityId',
        label: translate?.instant('LOCATION_MANAGEMENT.CITY'),
        placeholder: `${translate?.instant('GENERAL.SELECT')}`,
        widthClass: 'col-12',
        defaultValue: address?.cityId || address?.city?.id,
        isDisable: !visiable,
        listValues: this.cities,
        change: (value: string) => {
          if (onCityChange) {
            onCityChange(value);
          }
        }
        // validation: [
        //   {
        //     function: Validators.required,
        //     errorMessage: translate?.instant('GENERAL.PLEASE_SELECT') + ' ' + translate?.instant('LOCATION_MANAGEMENT.CITY')
        //   }
        // ]
      },
      {
        type: AllInputTypes.Select,
        name: 'districtId',
        label: translate?.instant('LOCATION_MANAGEMENT.DISTRICT'),
        placeholder: `${translate?.instant('GENERAL.SELECT')}`,
        widthClass: 'col-12',
        defaultValue: address?.districtId || address?.district?.id,
        isDisable: !visiable,
        listValues: this.districts
        // validation: [
        //   {
        //     function: Validators.required,
        //     errorMessage: translate?.instant('GENERAL.PLEASE_SELECT') + ' ' + translate?.instant('LOCATION_MANAGEMENT.DISTRICT')
        //   }
        // ]
      },
      {
        type: AllInputTypes.Text,
        name: 'addressLine1',
        label: translate?.instant('LOCATION_MANAGEMENT.ADDRESS_LINE_1'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.ADDRESS_LINE_1')}`,
        isDisable: !visiable,
        defaultValue: address?.addressLine1,
        widthClass: 'col-12'
      },
      {
        type: AllInputTypes.Text,
        name: 'addressLine2',
        label: translate?.instant('LOCATION_MANAGEMENT.ADDRESS_LINE_2'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.ADDRESS_LINE_2')}`,
        isDisable: !visiable,
        defaultValue: address?.addressLine2,
        widthClass: 'col-12'
      }
      // {
      //   type: AllInputTypes.Map,
      //   name: 'location',
      //   label: translate?.instant('LOCATION_MANAGEMENT.LOCATION'),
      //   isDisable: !visiable,
      //   defaultValue: address?.location,
      //   locations: [
      //     { lat: address?.location?.latitude || 24.88122384852, lng: address?.location?.longitude || 46.660305165501 }
      //   ],
      //   enableQuickLatLongSearch: false
      // },
    ];
    return this.form;
  }

  updateListValues<T extends { id: string; englishName: string, arabicName: string}>(
    items: T[],
    targetProperty: 'geographicalZones' | 'states' | 'cities' | 'districts',
    formFieldName: 'geographicalZoneId' | 'stateId' | 'cityId' | 'districtId'
  ): void {
    this[targetProperty] = [
      ...items.map((item) => ({
        label: this.publicService.getCurrentLang() == 'en' ? item.englishName : item.arabicName,
        value: item.id
      }))
    ];

    const formField = this.form.find((field) => field.name === formFieldName);
    if (formField) {
      formField.listValues = this[targetProperty];
    }
    this.cdr.detectChanges();
  }
}
